import { z } from 'zod'

import { DailyAllowanceModelZ, DailyAllowanceResponseZ } from './dailyAllowance'
import { MileageModelZ, MileageResponseZ } from './mileage'
import { StandardExpenseModelZ, StandardExpenseResponseZ } from './standardExpense'

export const ExpenseResponseUnionZ = z.union([StandardExpenseResponseZ, MileageResponseZ, DailyAllowanceResponseZ])
export type ExpenseResponseUnion = z.infer<typeof ExpenseResponseUnionZ>

const ExpenseModelUnionZ = z.union([StandardExpenseModelZ, MileageModelZ, DailyAllowanceModelZ])
export type ExpenseModelUnion = z.infer<typeof ExpenseModelUnionZ>
